import { forwardRef, Fragment, useMemo } from 'react'

//* Style
import PathsStyle from './style'

//* Components
import CustomLink from 'components/common/CustomLink'
import Icon from 'components/common/Icon'
import Text from 'components/common/Text'

const Paths = forwardRef(({ paths, pathColor, isHero }, ref) => {
	//! Store paths
	const storePaths = useMemo(() => {
		return paths.map((path, index) => {
			return (
				<Fragment key={index}>
					{path.name ? (
						<CustomLink url={`/${path.url}`}>
							<Text className={`font-ping-medium uppercase ${pathColor} pXS`} text={path.name} />
						</CustomLink>
					) : (
						<Text className={`path-name uppercase font-ping-medium ${pathColor} pXS`} text={path} />
					)}
					{index + 1 === paths.length ? null : <Icon name={'arrow-path'} className={`arrow-right ${pathColor}`} />}
				</Fragment>
			)
		})
	}, [paths])

	return (
		<PathsStyle ref={ref} className={`path-wrap ${isHero ? 'hero-section' : ''}`}>
			<div className='scroll-wrap'>{storePaths}</div>
		</PathsStyle>
	)
})

Paths.defaultProps = {
	pathColor: '',
}

export default Paths
